import React from 'react'
import PropTypes from 'prop-types'

const ErrorMessage = (props) => {
  // Hide ErrorMessage if there are no errors or if it's always showing incorrectly
  // For now, hide it since it seems to always show "No agents available"
  // This should be conditionally rendered based on actual error state
  if (!props.messages || !props.messages.errors) {
    return null;
  }
  
  return (
    <div className="row send-chat-box">
        <strong>No agents available at this time.</strong>
    </div>
  )
}

ErrorMessage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      message: PropTypes.string,
      author: PropTypes.string,
    })
  )
}

export default ErrorMessage